export const GLOSSARY = [
  {
    "key": 1,
    "value": "Acceptable use policy",
    "description": "A security policy that defines the types of activities and tools that are acceptable and those that are not acceptable to the organization."
  },
  {
    "key": 2,
    "value": "Accountability",
    "description": "The concept that organizational management is accountable for the decisions and other outcomes generated by AI systems."
  },
  {
    "key": 3,
    "value": "Accuracy",
    "description": "In AI system validation testing, the percentage of total correct predictions. See also F1 score, precision, and recall."
  },
  {
    "key": 4,
    "value": "Adversarial input",
    "description": "Data input intended to cause harm, such as denial-of-service or fraud. See also denial of service (DoS)."
  },
  {
    "key": 5,
    "value": "After-action review (AAR)",
    "description": "A review that follows an activity, in which the activity and its successes, failures, and issues are discussed and action items created to make key improvements."
  },
  {
    "key": 6,
    "value": "AI agent",
    "description": "An autonomous system that perceives its environment through incoming sensor information and takes actions to achieve specific goals."
  },
  {
    "key": 7,
    "value": "AI deployer (organization)",
    "description": "See deployer (organization)."
  },
  {
    "key": 8,
    "value": "AI deployer (person)",
    "description": "See deployer (person)."
  },
  {
    "key": 9,
    "value": "AI developer",
    "description": "An individual or team in an organization that designs, builds, trains, and evaluates AI models or systems."
  },
  {
    "key": 10,
    "value": "AI distributor",
    "description": "An organization making AI systems available in the EU market, without modifying them or acting as importers. See also AI deployer, AI developer."
  },
  {
    "key": 11,
    "value": "AI impact assessment (AIIA)",
    "description": "An assessment to identify and manage potential harms and unintended consequences of an AI system prior to deployment. See also algorithmic impact assessment (AIA)."
  },
  {
    "key": 12,
    "value": "AI importer",
    "description": "See importer."
  },
  {
    "key": 13,
    "value": "AI incident",
    "description": "Any unexpected behavior, outcome, or interaction that causes (or has the potential to cause) harm, disruption, or regulatory concern."
  },
  {
    "key": 14,
    "value": "AI provider",
    "description": "See provider."
  },
  {
    "key": 15,
    "value": "AI RMF",
    "description": "See NIST AI RMF."
  },
  {
    "key": 16,
    "value": "AI system bill of materials (AI-SBOM)",
    "description": "The complete record of all hardware, software, and training components of an AI system. See also software bill of materials (SBOM)."
  },
  {
    "key": 17,
    "value": "AI user",
    "description": "An individual who interacts with AI systems during their operational use."
  },
  {
    "key": 18,
    "value": "Aleatoric uncertainty",
    "description": "Inherent randomness in AI system inputs, such as noise in sensor data."
  },
  {
    "key": 19,
    "value": "Algorithm",
    "description": "In AI, a technique for detecting patterns and anomalies."
  },
  {
    "key": 20,
    "value": "Algorithmic impact assessment (AIA)",
    "description": "A risk assessment used to identify potential societal (and other) impacts of an AI model before it is put into use. See also AI impact assessment (AIIA)."
  },
  {
    "key": 21,
    "value": "Anonymization",
    "description": "The practice of removing names and other personal details from a dataset, so that the data cannot be linked to specific individuals. See also pseudonymization."
  },
  {
    "key": 22,
    "value": "ARCI",
    "description": "See RACI."
  },
  {
    "key": 23,
    "value": "Artificial general intelligence (AGI)",
    "description": "See general AI."
  },
  {
    "key": 24,
    "value": "Artificial intelligence",
    "description": "The simulation of human intelligence processes by machines, generally computer systems. These processes include learning, reasoning, problem-solving, perception, and language understanding."
  },
  {
    "key": 25,
    "value": "Artificial superintelligence (ASI)",
    "description": "An AI that surpasses human intelligence in all aspects— creativity, problem-solving, emotional understanding, and decision-making. ASI does not yet exist, as far as we know."
  },
  {
    "key": 26,
    "value": "Assurance",
    "description": "Evidence-based confidence that a system will behave as intended under defined conditions."
  },
  {
    "key": 27,
    "value": "Assurance of AI systems program (ARIA)",
    "description": "See NIST ARIA (National Institute for Standards and Technology Assessing Risks and Impacts of AI Systems)."
  },
  {
    "key": 28,
    "value": "Attack surface",
    "description": "The set of hardware and software components present on a system or in an environment that an attacker can potentially exploit."
  },
  {
    "key": 29,
    "value": "Attorney-client privilege",
    "description": "A legal doctrine in the United States and elsewhere in which the correspondence between an attorney and their client is confidential (privileged) and not subject to discovery or disclosure."
  },
  {
    "key": 30,
    "value": "Audit log",
    "description": "An electronic record of events or transactions that is separate from primary business records."
  },
  {
    "key": 31,
    "value": "Automation bias",
    "description": "The tendency for humans to favor output from an automated system, even when it is incorrect."
  },
  {
    "key": 32,
    "value": "Autonomous",
    "description": "See autonomy."
  },
  {
    "key": 33,
    "value": "Autonomy",
    "description": "A characteristic of an AI system in which it takes action without human initiation or intervention."
  },
  {
    "key": 34,
    "value": "Backward lineage",
    "description": "The tracking records of a dataset back to its origin, including its sources, transformations, and ownership. Otherwise known as data provenance."
  },
  {
    "key": 35,
    "value": "Benchmarking",
    "description": "The practice of measuring a process to compare its performance and quality with the same process at an earlier point in time, or as performed by another organization. The purpose is to identify opportunities for improvement that lead to lower costs, reduced resource utilization, and higher quality."
  },
  {
    "key": 36,
    "value": "Bias",
    "description": "A systematic deviation in an AI system’s predictions or decisions that favors certain outcomes or groups over others. Bias can result from skewed data, flawed model design, or human assumptions."
  },
  {
    "key": 37,
    "value": "Bias mitigation",
    "description": "Measures to correct bias in an AI system."
  },
  {
    "key": 38,
    "value": "Binary classification",
    "description": "An algorithm in which an AI or ML model classifies an input as one of two classes."
  },
  {
    "key": 39,
    "value": "Binding contract",
    "description": "See contract."
  },
  {
    "key": 40,
    "value": "Binding corporate rules (BCR)",
    "description": "Internal data protection policies adopted by multinational organizations to allow the transfer of personal data across national borders within the organization. See also standard contractual clauses (SCC)."
  },
  {
    "key": 41,
    "value": "Biometrics",
    "description": "Any use of a machine-readable characteristic of a user’s body that uniquely identifies the user. Biometrics can be used for strong authentication. Types of biometrics include voice recognition, fingerprint recognition, hand scan, palm vein scan, iris scan, retina scan, facial recognition, and handwriting recognition."
  },
  {
    "key": 42,
    "value": "Blue teaming",
    "description": "A detailed analysis of a system’s protective measures to identify the effectiveness of those protective measures, as well as flaws."
  },
  {
    "key": 43,
    "value": "Business alignment",
    "description": "The concept of developing policies, processes, and procedures that align with an organization’s mission, goals, objectives, size, sector, and culture."
  },
  {
    "key": 44,
    "value": "Business associate agreement (BAA)",
    "description": "A legal agreement that is required of any HIPAAcovered entity if it intends to share healthcare data with a third party that handles protected health information (PHI). The purpose of the legal agreement is to require the third party to comply with all applicable HIPAA regulations."
  },
  {
    "key": 45,
    "value": "Business case",
    "description": "A documented justification of the expected benefits, costs, and impact to the business that will be realized as a result of a program or project."
  },
  {
    "key": 46,
    "value": "Business context",
    "description": "The organizational, strategic, and operational environment in which an AI system will be used."
  },
  {
    "key": 47,
    "value": "Business functional requirements",
    "description": "See functional requirements."
  },
  {
    "key": 48,
    "value": "Center of excellence (COE)",
    "description": "An organized group of organizational personnel from throughout an organization that exchanges ideas and assistance."
  },
  {
    "key": 49,
    "value": "Change control",
    "description": "See change management."
  },
  {
    "key": 50,
    "value": "Change management",
    "description": "The IT function responsible for controlling changes to an IT environment. See also IT service management (ITSM)."
  },
  {
    "key": 51,
    "value": "Chilling effect",
    "description": "The inhibition or discouragement of lawful activities and rights, usually caused by some external stimulus."
  },
  {
    "key": 52,
    "value": "COBIT",
    "description": "A framework for governance and management of enterprise IT, developed by the IT Governance Institute and managed by ISACA."
  },
  {
    "key": 53,
    "value": "Complexity",
    "description": "A characteristic of an AI system that can make it difficult to explain its function precisely."
  },
  {
    "key": 54,
    "value": "Compliance risk",
    "description": "Risks associated with the consequences of failing to comply with applicable laws and regulations and, to a lesser extent, with specific obligations stipulated in contracts."
  },
  {
    "key": 55,
    "value": "Concept drift",
    "description": "Drift of an AI system in which the model no longer reflects the real world."
  },
  {
    "key": 56,
    "value": "Configuration management",
    "description": "The IT function in which the configuration of components in an IT environment is independently recorded. Configuration management is usually supported using automated tools that inventory and control system configurations. See also IT service management (ITSM)."
  },
  {
    "key": 57,
    "value": "Configuration management database (CMDB)",
    "description": "A centralized repository that stores information about the configuration items (CIs) in an organization’s IT environment and their relationships, providing traceability and support for change and incident management."
  },
  {
    "key": 58,
    "value": "Conformity assessment",
    "description": "A structured process of evaluating whether a system or product meets defined standards, regulations, or requirements."
  },
  {
    "key": 59,
    "value": "Consent",
    "description": "A voluntary agreement to the processing of a data subject’s information."
  },
  {
    "key": 60,
    "value": "Containerization",
    "description": "A technique in which multiple instances of a software program can be executed on an operating system."
  },
  {
    "key": 61,
    "value": "Continuous improvement",
    "description": "The cultural mindset that organizations should strive to incrementally improve business processes and information systems, to make them more efficient, resilient, compliant, and secure."
  },
  {
    "key": 62,
    "value": "Continuous integration (CI)",
    "description": "A software development practice where developers frequently integrate their code changes into a centralized code repository, often multiple times each day."
  },
  {
    "key": 63,
    "value": "Continuous monitoring",
    "description": "Any means used to ensure the proper function of a system in near real time."
  },
  {
    "key": 64,
    "value": "Control",
    "description": "A policy, process, or procedure that is created to achieve a desired event or to avoid an unwanted event. See also security controls."
  },
  {
    "key": 65,
    "value": "Copyright",
    "description": "Legal protection granted to the owner of a creative work, with exclusive rights to copy, distribute, adapt, display, or perform the work."
  },
  {
    "key": 66,
    "value": "Correlated proxy",
    "description": "A data input that is not a protected or targeted attribute but is statistically correlated with it and may lead to bias or discrimination."
  },
  {
    "key": 67,
    "value": "Cross-border data transfer",
    "description": "Data transferred into or out of a legal jurisdiction."
  },
  {
    "key": 68,
    "value": "Crowdsourcing",
    "description": "The utilization of large groups of dispersed participants who contribute to a task or project."
  },
  {
    "key": 69,
    "value": "Cyber insurance",
    "description": "An insurance product that protects organizations from risks related to information systems and cybersecurity."
  },
  {
    "key": 70,
    "value": "Cybersecurity framework (CSF)",
    "description": "See NIST CSF (National Institute of Standards and Technology Cybersecurity Framework)."
  },
  {
    "key": 71,
    "value": "Dark pattern",
    "description": "A user interface whose design is deliberately deceptive."
  },
  {
    "key": 72,
    "value": "Data augmentation",
    "description": "The technique of combining datasets to enrich the information about each data subject or other subject."
  },
  {
    "key": 73,
    "value": "Data classification",
    "description": "The process of assigning a sensitivity classification to a dataset or information asset."
  },
  {
    "key": 74,
    "value": "Data classification policy",
    "description": "A policy that defines sensitivity levels and handling procedures for information."
  },
  {
    "key": 75,
    "value": "Data flow diagram (DFD)",
    "description": "A visual depiction of data flows in or among systems."
  },
  {
    "key": 76,
    "value": "Data governance",
    "description": "Policies and practices through which enterprise data is classified and handled."
  },
  {
    "key": 77,
    "value": "Data Governance Institute (DGI) framework",
    "description": "A framework for the classification, organization, and decision-making regarding enterprise data."
  },
  {
    "key": 78,
    "value": "Data labeling",
    "description": "The process of tagging data with labels that facilitate data classification or categorization."
  },
  {
    "key": 79,
    "value": "Data lineage",
    "description": "The lifecycle of data within a system, documenting data flows and transformations. See also data provenance."
  },
  {
    "key": 80,
    "value": "Data loss prevention (DLP)",
    "description": "A set of technologies and processes designed to detect, monitor, and prevent the unauthorized transmission, exposure, or misuse of sensitive data across an organization’s systems and networks."
  },
  {
    "key": 81,
    "value": "Data Management Body of Knowledge (DMBOK)",
    "description": "A comprehensive reference guide containing best practices and vocabulary for enterprise data management."
  },
  {
    "key": 82,
    "value": "Data minimization",
    "description": "A data privacy principle in which an organization collects only the minimum amount of data required to provide stated services."
  },
  {
    "key": 83,
    "value": "Data nutrition label",
    "description": "A disclosure of the source and provenance of training data."
  },
  {
    "key": 84,
    "value": "Data owner",
    "description": "In data governance, an individual with authority and accountability for the strategic use of data."
  },
  {
    "key": 85,
    "value": "Data protection impact assessment (DPIA)",
    "description": "A risk assessment that seeks to identify risks related to the collection, use, and disposition of data, often privacy-related data."
  },
  {
    "key": 86,
    "value": "Data provenance",
    "description": "A business record that documents the origin and original characteristics of a dataset."
  },
  {
    "key": 87,
    "value": "Data provenance logs",
    "description": "Records of the sources and uses of data for training AI systems (and other uses)."
  },
  {
    "key": 88,
    "value": "Data quality",
    "description": "A characteristic of data that represents its accuracy and completeness."
  },
  {
    "key": 89,
    "value": "Data reconstruction attack",
    "description": "An attack on a dataset in which the attacker attempts to reidentify data subjects. See also reidentification."
  },
  {
    "key": 90,
    "value": "Data residency",
    "description": "The physical or geographical location where data is stored. See also data sovereignty."
  },
  {
    "key": 91,
    "value": "Data retention",
    "description": "The practice of retaining data for a specified period of time."
  },
  {
    "key": 92,
    "value": "Data sovereignty",
    "description": "The legal and regulatory control a government asserts over data within its borders. See also data residency."
  },
  {
    "key": 93,
    "value": "Data steward",
    "description": "In data governance, a person responsible for ensuring data quality, managing documentation, and resolving issues."
  },
  {
    "key": 94,
    "value": "Data subject request (DSR)",
    "description": "Any formal request made by a data subject to an organization regarding the collection or use of their personal information."
  },
  {
    "key": 95,
    "value": "Data sufficiency",
    "description": "Having enough data to train an AI model effectively."
  },
  {
    "key": 96,
    "value": "Database rights",
    "description": "Legal rights that limit the use of databases for training AI systems, thereby protecting the economic investment in those databases."
  },
  {
    "key": 97,
    "value": "Decision-rights",
    "description": "A structured approach to defining and clarifying the roles and responsibilities of individuals involved in decision-making processes."
  },
  {
    "key": 98,
    "value": "Deep learning",
    "description": "A subset of machine learning that uses artificial neural networks consisting of multiple layers and trained on large datasets."
  },
  {
    "key": 99,
    "value": "Deepfake",
    "description": "Any image, video, or audio created by an AI system that may depict a real or fictitious person or event."
  },
  {
    "key": 100,
    "value": "Deidentification",
    "description": "Techniques such as anonymization and pseudonymization that remove sensitive personal data from datasets. See also anonymization, pseudonymization, reidentification."
  },
  {
    "key": 101,
    "value": "Denial of service (DoS)",
    "description": "An attack on a computer or network with the intention of causing disruption or degrading the availability of the target."
  },
  {
    "key": 102,
    "value": "Deployer (organization)",
    "description": "An organization responsible for integrating AI models into production environments and operational workflows. See also deployer (person)."
  },
  {
    "key": 103,
    "value": "Deployer (person)",
    "description": "An individual or team in an organization responsible for integrating AI models into production environments and operational workflows. See also deployer (organization)."
  },
  {
    "key": 104,
    "value": "Deterministic",
    "description": "A characteristic of an AI system in which its outputs are predictable and repeatable. See also probabilistic, nondeterminism."
  },
  {
    "key": 105,
    "value": "Developer",
    "description": "See AI developer."
  },
  {
    "key": 106,
    "value": "Differential exposure",
    "description": "A phenomenon where an AI system provides different information or outcomes to users or groups based on group membership (for example, race, age, gender), not due to explicit bias but due to structural or statistical differences in the AI system’s function or learning."
  },
  {
    "key": 107,
    "value": "Differential privacy",
    "description": "A technique for publishing information (for example, statistics) about a dataset, while protecting the privacy of data subjects."
  },
  {
    "key": 108,
    "value": "Digital twin",
    "description": "A digital model of a real-world physical product, process, or system, typically created for evaluation or testing."
  },
  {
    "key": 109,
    "value": "Distillation",
    "description": "A technique where a smaller AI model is trained to replicate the behavior of a larger AI model."
  },
  {
    "key": 110,
    "value": "Distributor",
    "description": "See AI distributor."
  },
  {
    "key": 111,
    "value": "Downsampling",
    "description": "Reducing the number of data points in a dataset, usually by randomly removing data points. See also upsampling."
  },
  {
    "key": 112,
    "value": "Downstream harm",
    "description": "The consequences of AI outputs that are felt by individuals, communities, or systems not initially considered by the developer or deployer."
  },
  {
    "key": 113,
    "value": "Drift",
    "description": "See model drift."
  },
  {
    "key": 114,
    "value": "Dropout",
    "description": "A technique in AI to prevent overfitting in neural networks. See also L1 regularization, L2 regularization."
  },
  {
    "key": 115,
    "value": "Emergent behavior",
    "description": "Unexpected or unplanned outcomes that arise when an AI system exhibits capabilities or patterns beyond those explicitly programmed or intended by its designers. Emergent behavior may be either beneficial or harmful."
  },
  {
    "key": 116,
    "value": "Ensemble modeling",
    "description": "The process of combining multiple models to create a stronger, more robust model."
  },
  {
    "key": 117,
    "value": "Enterprise risk management (ERM)",
    "description": "An organization-wide, lifecycle process in which periodic risk assessments and other activities identify risks, which are documented, analyzed, and treated."
  },
  {
    "key": 118,
    "value": "Epistemic uncertainty",
    "description": "The risk of an AI system producing incorrect output, due to gaps in the AI system’s knowledge (usually as a result of incomplete training data or model design flaws)."
  },
  {
    "key": 119,
    "value": "Equitable access",
    "description": "The fair treatment of persons subjected to AI-powered decision-making systems."
  },
  {
    "key": 120,
    "value": "Ethical oversight",
    "description": "A governance safeguard to ensure that AI systems are ethically designed and operated."
  },
  {
    "key": 121,
    "value": "Ethics",
    "description": "The principles relating to right and wrong conduct."
  },
  {
    "key": 122,
    "value": "EU Copyright Directive",
    "description": "A 2019 EU law that modernizes copyright rules across EU member states."
  },
  {
    "key": 123,
    "value": "EU Digital Services Act (DSA)",
    "description": "A 2022 EU regulation that addresses illegal content, transparent advertising, and disinformation."
  },
  {
    "key": 124,
    "value": "Exfiltration",
    "description": "The act of transmitting files from one environment to another location, often as part of data theft."
  },
  {
    "key": 125,
    "value": "Expert system",
    "description": "An AI system that simulates the decision-making ability of a human expert in a particular field."
  },
  {
    "key": 126,
    "value": "Explainability",
    "description": "A characteristic of an AI system in which humans can explain its decisions or outputs. See also interpretability."
  },
  {
    "key": 127,
    "value": "Explainability theater",
    "description": "The elaborate and futile act of pretending to explain how an AI model works, when the organization has no idea."
  },
  {
    "key": 128,
    "value": "Explainable AI (XAI)",
    "description": "A characteristic of an AI system in which humans can explain its decisions or outputs."
  },
  {
    "key": 129,
    "value": "Explicit consent",
    "description": "A voluntary and intentional grant by a data subject of subject data usage to an organization or agency. See also implicit consent."
  },
  {
    "key": 130,
    "value": "Exploratory data analysis (EDA)",
    "description": "A data analysis technique to summarize a dataset’s main characteristics using statistical graphics and data visualization."
  },
  {
    "key": 131,
    "value": "F1 score",
    "description": "In AI system validation testing, a combined measure of precision and recall that balances both. See also accuracy, precision, and recall."
  },
  {
    "key": 132,
    "value": "Failsafe",
    "description": "A mechanism that ensures that a system will continue to function as intended, even in adverse and unexpected conditions."
  },
  {
    "key": 133,
    "value": "Fair use",
    "description": "A doctrine in U.S. law that permits limited use of copyrighted material without being required to obtain permission from copyright owners."
  },
  {
    "key": 134,
    "value": "Fairness",
    "description": "A characteristic of an AI system’s outputs to be free of biases and not systematically disadvantage individuals or groups."
  },
  {
    "key": 135,
    "value": "Fault tolerance",
    "description": "A characteristic of a system that consists of redundant components and other safeguards to ensure it will continue to function in adverse conditions, including component failure."
  },
  {
    "key": 136,
    "value": "Feature importance",
    "description": "A measure of how much each input variable in training data contributes to predictions made by an AI model."
  },
  {
    "key": 137,
    "value": "Federal Trade Commission (FTC) Act",
    "description": "A U.S. law that forbids unfair and deceptive acts and practices in consumer commerce."
  },
  {
    "key": 138,
    "value": "Federated learning",
    "description": "A model training technique where multiple entities train a model while keeping data decentralized."
  },
  {
    "key": 139,
    "value": "Feedback loop",
    "description": "A cyclical process where outputs of an AI system are reintroduced as inputs."
  },
  {
    "key": 140,
    "value": "Forum shopping",
    "description": "The practice of researching legal jurisdictions to ensure a favorable legal outcome."
  },
  {
    "key": 141,
    "value": "Forward lineage",
    "description": "The tracking records of a dataset from its origin, throughout its time of use. See also lineage."
  },
  {
    "key": 142,
    "value": "FTC Act",
    "description": "See Federal Trade Commission (FTC) Act."
  },
  {
    "key": 143,
    "value": "Function creep",
    "description": "The practice of using an AI system or its training data beyond its stated original purposes."
  },
  {
    "key": 144,
    "value": "Functional requirements",
    "description": "Statements that describe the required characteristics that a system must have to support business needs. See also regulatory requirements, security requirements, technical requirements."
  },
  {
    "key": 145,
    "value": "Fuzzing",
    "description": "A software testing technique in which invalid, unexpected, random, and malicious data is input to a system to observe its behavior."
  },
  {
    "key": 146,
    "value": "Gap analysis",
    "description": "An analysis of a process or system against a standard to see where the process or system meets the standard and where it falls short."
  },
  {
    "key": 147,
    "value": "Gate process",
    "description": "Any business process that consists of one or more review/approval steps, which must be completed before the process may continue."
  },
  {
    "key": 148,
    "value": "General AI",
    "description": "A form of AI that can understand, learn, and apply intelligence across various tasks, much like a human being."
  },
  {
    "key": 149,
    "value": "General-purpose AI (GPAI)",
    "description": "AI models that can serve multiple intended purposes and be integrated into a variety of systems and applications."
  },
  {
    "key": 150,
    "value": "Generative AI",
    "description": "A type of limited AI system that creates new content that mimics the structure and style of content used to train it."
  },
  {
    "key": 151,
    "value": "Geofencing",
    "description": "A network access control to limit access to a service or system based on the geographic location of a user."
  },
  {
    "key": 152,
    "value": "God-like AI",
    "description": "A level of AI beyond artificial superintelligence that surpasses human cognition to become incomprehensible. God-like AI does not yet exist."
  },
  {
    "key": 153,
    "value": "Governance",
    "description": "Management’s control over policy and processes."
  },
  {
    "key": 154,
    "value": "Ground truth",
    "description": "In AI system testing, a deterministic, authoritative, and correct answer to a given input."
  },
  {
    "key": 155,
    "value": "Hallucination",
    "description": "The occurrence of an AI system that generates output that is false, misleading, or not grounded in training data or real-world facts."
  },
  {
    "key": 156,
    "value": "Health Insurance Portability and Accountability Act (HIPAA)",
    "description": "A U.S. regulation requiring healthcare delivery organizations, health insurance companies, and other healthcare industry entities to secure and maintain the privacy of electronic protected health information (ePHI)."
  },
  {
    "key": 157,
    "value": "High-level expert group (HLEG)",
    "description": "An expert group, designated by the European Commission, that defined ethical principles for trustworthy AI."
  },
  {
    "key": 158,
    "value": "High-risk AI",
    "description": "One of the classification levels defined in the EU AI Act. See also limited-risk AI, minimal-risk AI, and prohibited AI."
  },
  {
    "key": 159,
    "value": "Homomorphic encryption",
    "description": "An encryption technique in which computations may be performed on encrypted data without first having to decrypt it."
  },
  {
    "key": 160,
    "value": "Human centricity",
    "description": "A characteristic of an AI system in which its design reflects well-being and dignity."
  },
  {
    "key": 161,
    "value": "Human-centered design",
    "description": "Principles of system design in which systems serve human interests and align with ethical norms."
  },
  {
    "key": 162,
    "value": "Human-in-command",
    "description": "A governance principle in AI where ultimate authority and accountability remain with humans. See also human-in-the-loop (HITL), human-on-the-loop (HOTL)."
  },
  {
    "key": 163,
    "value": "Human-in-the-loop (HITL)",
    "description": "An AI-enhanced decision-making process in which a human worker reviews some or all of the decisions made by an AI system. See also human-in-command, human-on-the-loop (HOTL)."
  },
  {
    "key": 164,
    "value": "Human-on-the-loop (HOTL)",
    "description": "Human monitoring of an AI system during execution, with the ability to intervene in the AI system’s operation. See also human-in-command, human-in-theloop (HITL)."
  },
  {
    "key": 165,
    "value": "Human override",
    "description": "The ability for a person in a human-in-the-loop situation to overturn a decision made by an AI system."
  },
  {
    "key": 166,
    "value": "Impact assessment",
    "description": "The analysis of a threat and its potential impact if realized."
  },
  {
    "key": 167,
    "value": "Implicit consent",
    "description": "An assumption of a grant of subject data usage to an organization or agency. See also explicit consent."
  },
  {
    "key": 168,
    "value": "Importer",
    "description": "An organization that places AI systems from non-EU countries onto the EU market."
  },
  {
    "key": 169,
    "value": "Immutable",
    "description": "A property of information that prevents its modification or deletion."
  },
  {
    "key": 170,
    "value": "Incident",
    "description": "Any event that is not part of the standard operation of a service and that causes, or may cause, interruption to or a reduction in the quality of that service."
  },
  {
    "key": 171,
    "value": "Incident management",
    "description": "The IT function that analyzes service outages, service slowdowns, security incidents, and software bugs and seeks to resolve them to restore normal service. See also IT service management (ITSM)."
  },
  {
    "key": 172,
    "value": "Incident response plan (IRP)",
    "description": "A written set of principles, roles, responsibilities, and procedures to be followed when an incident occurs. See also playbook."
  },
  {
    "key": 173,
    "value": "Indicator of compromise (IOC)",
    "description": "Any reliable evidence that is a sign that an intrusion or attack has taken place or is taking place."
  },
  {
    "key": 174,
    "value": "Inference latency",
    "description": "The time it takes for an AI system to process an input and produce an output."
  },
  {
    "key": 175,
    "value": "Inferential privacy violation",
    "description": "A violation of privacy when a system deduces sensitive characteristics about a data subject from unrelated data."
  },
  {
    "key": 176,
    "value": "Information classification",
    "description": "See data classification."
  },
  {
    "key": 177,
    "value": "Inherent risk",
    "description": "The risk that material weaknesses are present in existing business processes and that no compensating controls are in place to detect or prevent them."
  },
  {
    "key": 178,
    "value": "Input controls",
    "description": "Controls that ensure the accuracy and validity of data to be input into a system. See also output controls."
  },
  {
    "key": 179,
    "value": "Integration",
    "description": "The assemblage of system components as a part of a whole system."
  },
  {
    "key": 180,
    "value": "Intellectual property (IP)",
    "description": "A class of assets owned by an organization, including the organization’s designs, architectures, software source code, processes, and procedures."
  },
  {
    "key": 181,
    "value": "Inter-rater reliability",
    "description": "The level of agreement or consistency among multiple raters or observers when they assess the same phenomenon."
  },
  {
    "key": 182,
    "value": "Interpretability",
    "description": "The ability to understand how AI processes information and comprehends the relationships between different patterns. See also explainability."
  },
  {
    "key": 183,
    "value": "Interruptibility",
    "description": "A characteristic of a system in which its integrity is preserved when processing is interrupted."
  },
  {
    "key": 184,
    "value": "ISO/IEC 20000",
    "description": "An ISO/IEC standard for IT service management (ITSM)."
  },
  {
    "key": 185,
    "value": "ISO/IEC 22989",
    "description": "An ISO/IEC standard that defines core concepts and terminology for artificial intelligence."
  },
  {
    "key": 186,
    "value": "ISO/IEC 23894",
    "description": "An ISO/IEC standard for AI risk management."
  },
  {
    "key": 187,
    "value": "ISO/IEC TR 24028",
    "description": "An ISO/IEC standard for trustworthiness in AI."
  },
  {
    "key": 188,
    "value": "ISO/IEC 27001",
    "description": "An ISO/IEC standard for IT information security management."
  },
  {
    "key": 189,
    "value": "ISO/IEC 38505-1",
    "description": "An ISO/IEC standard for data governance."
  },
  {
    "key": 190,
    "value": "ISO/IEC 42001",
    "description": "An ISO/IEC standard for AI governance and management."
  },
  {
    "key": 191,
    "value": "ISO/IEC 42005",
    "description": "An ISO/IEC standard for AI impact assessments."
  },
  {
    "key": 192,
    "value": "ISO/IEC 5181",
    "description": "An international standard for data security, privacy, and provenance. The standard is still in draft at the time of this publication."
  },
  {
    "key": 193,
    "value": "ISO 9000 and 9001",
    "description": "ISO standards for a quality management system."
  },
  {
    "key": 194,
    "value": "IT service management (ITSM)",
    "description": "The set of practices that ensures that the efficient and effective delivery of IT services is through active management and continuous process improvement. See also ISO/IEC 20000."
  },
  {
    "key": 195,
    "value": "Jailbreak",
    "description": "An attack against a system that results in the bypass of its protective controls, thereby permitting disallowed behavior."
  },
  {
    "key": 196,
    "value": "Key performance indicator (KPI)",
    "description": "A measure of business processes’ performance and quality, used to reveal trends related to the efficiency and effectiveness of key processes in the organization."
  },
  {
    "key": 197,
    "value": "Kill switch",
    "description": "Any mechanism that is used to suspend a system’s operation or shut it down, generally in an emergency of some sort."
  },
  {
    "key": 198,
    "value": "L1 regularization",
    "description": "A technique in AI to prevent overfitting by adding a penalty based on the absolute value of one or more model parameters. See also dropout."
  },
  {
    "key": 199,
    "value": "L2 regularization",
    "description": "A technique in AI to prevent overfitting by adding a penalty based on the square of one or more model parameters. See also dropout."
  },
  {
    "key": 200,
    "value": "Large language model (LLM)",
    "description": "A type of narrow AI that is trained on massive datasets of text and capable of understanding and generating human-like text based on input prompts."
  },
  {
    "key": 201,
    "value": "Learning management system (LMS)",
    "description": "An information system that manages and delivers training content."
  },
  {
    "key": 202,
    "value": "Limited memory AI",
    "description": "An AI system with limited memory that retains information for short periods and uses that information to improve its performance."
  },
  {
    "key": 203,
    "value": "Limited-risk AI",
    "description": "One of the classification levels defined in the EU AI Act. See also high-risk AI, minimal-risk AI, and prohibited AI."
  },
  {
    "key": 204,
    "value": "Localization",
    "description": "Adapting an AI system for a particular jurisdiction."
  },
  {
    "key": 205,
    "value": "Logistic regression",
    "description": "An AI or ML algorithm used for binary classification tasks."
  },
  {
    "key": 206,
    "value": "Machine learning",
    "description": "An AI technique that enables systems to learn from input data, improve their performance, and make decisions without explicit programming. ML systems are trained on large datasets and learn to make predictions based on patterns found in the data."
  },
  {
    "key": 207,
    "value": "Maturity model",
    "description": "A scale of maturity levels of a process or organization with brief descriptions for each level."
  },
  {
    "key": 208,
    "value": "Membership inference attack",
    "description": "An attack on an AI system in which the attacker attempts to determine whether specific data was used to train the system."
  },
  {
    "key": 209,
    "value": "Metadata",
    "description": "In the context of AI, structured data about data used to train an AI model, including the source, format, collection date, licensing, and any preprocessing."
  },
  {
    "key": 210,
    "value": "Minimal-risk AI",
    "description": "One of the classification levels defined in the EU AI Act. See also high-risk AI, limited-risk AI, and prohibited AI."
  },
  {
    "key": 211,
    "value": "Model bill of materials (MBOM)",
    "description": "See AI system bill of materials (AI-SBOM)."
  },
  {
    "key": 212,
    "value": "Model card",
    "description": "Documentation that provides detailed information about an AI model’s characteristics, intended use cases, limitations, ethical considerations, and other details."
  },
  {
    "key": 213,
    "value": "Model drift",
    "description": "The degradation of an AI model’s accuracy over time as data patterns change."
  },
  {
    "key": 214,
    "value": "Model driftwood",
    "description": "The debris left behind after countless “proof of concept” projects that never made it to production."
  },
  {
    "key": 215,
    "value": "Model fact sheet",
    "description": "A document that provides structured information about a specific AI model."
  },
  {
    "key": 216,
    "value": "Model inversion",
    "description": "An attack on an AI system in which the attacker attempts to obtain information about a data subject or other data intended to remain concealed."
  },
  {
    "key": 217,
    "value": "Model poisoning",
    "description": "An attack on an AI system in which the attacker uses one of several methods to manipulate the system’s training data, operating parameters, or other aspects to compromise the system’s security, performance, accuracy, or bias."
  },
  {
    "key": 218,
    "value": "Model registry",
    "description": "A repository used to store, version, track, and manage AI and ML models over their lifecycle. See also configuration management database (CMDB)."
  },
  {
    "key": 219,
    "value": "Model rollback",
    "description": "The reversion of an AI model to an earlier version, as a mitigation strategy when an AI model experiences problems."
  },
  {
    "key": 220,
    "value": "Model stacking",
    "description": "Multiple different models are trained on the same dataset, and their outputs are combined into a single result."
  },
  {
    "key": 221,
    "value": "Model wrapper",
    "description": "Software that encapsulates an AI model."
  },
  {
    "key": 222,
    "value": "Monitoring",
    "description": "The continuous or regular evaluation of a system or control to determine its operation or effectiveness."
  },
  {
    "key": 223,
    "value": "Monotonic relationship",
    "description": "A relationship where, as input increases, output never decreases, and where input decreases, output never increases."
  },
  {
    "key": 224,
    "value": "Narrow AI",
    "description": "A class of AI systems designed and trained to perform a specific task or a narrow set of tasks."
  },
  {
    "key": 225,
    "value": "Natural language processing (NLP)",
    "description": "A branch of AI focused on enabling systems to understand, interpret, and generate human language."
  },
  {
    "key": 226,
    "value": "NIST AI RMF (National Institute of Standards and Technology Artificial Intelligence Risk Management Framework)",
    "description": "A framework consisting of standards, guidelines, and best practices for managing AI-related risk, developed by the U.S. National Institute of Standards and Technology."
  },
  {
    "key": 227,
    "value": "NIST ARIA (National Institute for Standards and Technology Assessing Risks and Impacts of AI Systems)",
    "description": "A NIST program exploring AI system assurance methods."
  },
  {
    "key": 228,
    "value": "NIST CSF (National Institute for Standards and Technology Cybersecurity Framework)",
    "description": "A framework consisting of standards, guidelines, and best practices to manage cybersecurityrelated risk, developed by the U.S. National Institute of Standards and Technology."
  },
  {
    "key": 229,
    "value": "Non-functional requirements",
    "description": "See technical requirements."
  },
  {
    "key": 230,
    "value": "Nondeterminism",
    "description": "A characteristic of an AI system that may, for the same inputs, produce different outputs on different runs. See also deterministic."
  },
  {
    "key": 231,
    "value": "Nonrepudiation",
    "description": "The property of digital signatures and encryption that can make it difficult or impossible for a party to deny having sent a digitally signed message, unless they admit to having lost control of their private encryption key."
  },
  {
    "key": 232,
    "value": "Notice",
    "description": "A communication in which an individual is told about how their personal data will be collected, used, stored, and shared."
  },
  {
    "key": 233,
    "value": "Notice of privacy practices (NOPP)",
    "description": "An organization’s formal public statement that describes the PII that is collected, how it is used, and how data subjects may make inquiries and complaints."
  },
  {
    "key": 234,
    "value": "Notified body",
    "description": "In the EU AI Act, a third-party organization, designated by an EU member state, that is responsible for assessing AI systems."
  },
  {
    "key": 235,
    "value": "Observability",
    "description": "The ability to understand why an AI model produces a given output."
  },
  {
    "key": 236,
    "value": "OECD AI principles",
    "description": "An international agreed-upon set of guidelines for trustworthy AI."
  },
  {
    "key": 237,
    "value": "Opacity",
    "description": "A characteristic of an AI system in which its precise reasoning is difficult to explain. See also explainability."
  },
  {
    "key": 238,
    "value": "Open source",
    "description": "Source code that is made freely available for use, enhancement, and distribution."
  },
  {
    "key": 239,
    "value": "Opt-in",
    "description": "An explicit action or informed choice by an individual to consent to participation, data collection, or communications with an organization."
  },
  {
    "key": 240,
    "value": "Opt-out",
    "description": "An explicit action or mechanism allowing an individual to withdraw consent or decline participation in communications or data processing."
  },
  {
    "key": 241,
    "value": "Output controls",
    "description": "Controls that ensure the accuracy and validity of final calculations and transformations. See also input controls."
  },
  {
    "key": 242,
    "value": "Overfitting",
    "description": "The result when an AI model is trained with too much narrow or repetitive data, and it learns irrelevant patterns. See also underfitting."
  },
  {
    "key": 243,
    "value": "Parallel testing",
    "description": "See shadow mode testing."
  },
  {
    "key": 244,
    "value": "Patent",
    "description": "A form of intellectual property, typically the design of a product or process, that is registered to its owner, published, and provides economic exclusivity and protection for a period of time."
  },
  {
    "key": 245,
    "value": "Peer review",
    "description": "A formal or informal review of one’s work by a colleague in the same or similar role."
  },
  {
    "key": 246,
    "value": "Personally identifiable information (PII)",
    "description": "As defined in various regulations and standards, data elements about natural persons that represent non-public information, such as personal financial information, medical records, religious and social affiliations, political affiliations, and criminal history."
  },
  {
    "key": 247,
    "value": "Pilot",
    "description": "A release of a system to a limited group of users, as a final step in system testing prior to general release."
  },
  {
    "key": 248,
    "value": "Playbook",
    "description": "A detailed set of instructions to be followed when a specific type of incident occurs."
  },
  {
    "key": 249,
    "value": "Policy",
    "description": "A statement that specifies a course, principle, or method of action that has been adopted in an organization. A policy typically defines who is responsible for monitoring and enforcing it."
  },
  {
    "key": 250,
    "value": "Post-market monitoring",
    "description": "See post-market surveillance."
  },
  {
    "key": 251,
    "value": "Post-market surveillance",
    "description": "The practice of monitoring the ongoing safety of a system or device after it is released to the market."
  },
  {
    "key": 252,
    "value": "Precision",
    "description": "In AI system validation testing, the fraction of test cases predicted as positive that were actually positive. See also accuracy, recall, and F1 score."
  },
  {
    "key": 253,
    "value": "Privacy",
    "description": "The protection of personal information from unauthorized disclosure, use, and distribution."
  },
  {
    "key": 254,
    "value": "Privacy by design (PbD)",
    "description": "An approach to system and process development that embeds privacy protections from the outset."
  },
  {
    "key": 255,
    "value": "Privacy impact assessment (PIA)",
    "description": "See data protection impact assessment (DPIA)."
  },
  {
    "key": 256,
    "value": "Privacy policy",
    "description": "A policy statement that defines how an organization will protect, manage, and handle private information."
  },
  {
    "key": 257,
    "value": "Probabilistic",
    "description": "A characteristic of AI systems in which their outputs are based on probability distributions. See also deterministic."
  },
  {
    "key": 258,
    "value": "Procedure",
    "description": "A written sequence of instructions used to complete a task."
  },
  {
    "key": 259,
    "value": "Process",
    "description": "A collection of one or more procedures used to perform a business function. See also procedure."
  },
  {
    "key": 260,
    "value": "Processor",
    "description": "Any party that processes personal data on behalf of a controller. See also controller."
  },
  {
    "key": 261,
    "value": "Product liability",
    "description": "A branch of tort law that holds manufacturers, designers, and sellers liable for placing defective products into commerce. See also tort law."
  },
  {
    "key": 262,
    "value": "Prohibited AI",
    "description": "One of the classification levels defined in the EU AI Act. See also high-risk AI, limited-risk AI, and minimal-risk AI."
  },
  {
    "key": 263,
    "value": "Prompt injection attack",
    "description": "An attack on an AI system in which an attacker intercepts and alters prompts sent to an AI system. Also, an attack on an AI system in which instructions are hidden in external data sources that the AI system processes."
  },
  {
    "key": 264,
    "value": "Protected class",
    "description": "Any demographic group that receives special protection under a law or regulation."
  },
  {
    "key": 265,
    "value": "Provider",
    "description": "A person or organization that develops an AI system or GPAI model with the intention of placing it on the EU market, under their own name or trademark."
  },
  {
    "key": 266,
    "value": "Proxy variables",
    "description": "Non-prohibited statistical factors that correlate with protected characteristics (for example, race, gender, ethnicity)."
  },
  {
    "key": 267,
    "value": "Pseudonymization",
    "description": "The practice of substituting fictitious names and other details of data records so that those records cannot be identified with the original data subjects. See also anonymization."
  },
  {
    "key": 268,
    "value": "Purpose creep",
    "description": "The gradual and unauthorized expansion of the use of personal data beyond its original intent."
  },
  {
    "key": 269,
    "value": "Purpose limitation",
    "description": "The practice of limiting the use of personally identifiable information to stated purposes."
  },
  {
    "key": 270,
    "value": "Quality management system (QMS)",
    "description": "A management system designed to identify and measure key quality characteristics of a system and respond to anomalies when they occur."
  },
  {
    "key": 271,
    "value": "Quantization",
    "description": "The process of reducing the mathematical precision of an AI model’s parameters from higher-precision formats to lower-precision formats."
  },
  {
    "key": 272,
    "value": "RACI",
    "description": "Stands for Responsible, Accountable, Consulted, and Informed. The responsibility model used to describe and track individual responsibilities in a business process or a project."
  },
  {
    "key": 273,
    "value": "Reactive machine",
    "description": "An AI system designed to respond to specific stimuli or inputs, without memory of past experiences."
  },
  {
    "key": 274,
    "value": "Reasoning AI",
    "description": "An AI system with advanced abilities to analyze and correlate patterns and make informed predictions."
  },
  {
    "key": 275,
    "value": "Recall",
    "description": "In AI system validation testing, of all the actual positive cases, the fraction that the AI model correctly identified. See also accuracy, F1 score, and precision."
  },
  {
    "key": 276,
    "value": "Records",
    "description": "Documents describing business events, such as meeting minutes, contracts, financial transactions, decisions, approvals, events, incidents, purchase orders, logs, and reports."
  },
  {
    "key": 277,
    "value": "Records retention schedule",
    "description": "A formal statement that specifies the retention of various types of business records in an organization."
  },
  {
    "key": 278,
    "value": "Recourse",
    "description": "Any mechanism, such as dispute resolution, for addressing adverse outcomes."
  },
  {
    "key": 279,
    "value": "Red teaming",
    "description": "A test of a system that simulates an attack, possibly falling short of complete exploitation, to avoid target system malfunction."
  },
  {
    "key": 280,
    "value": "Regulatory requirements",
    "description": "Formal statements, derived from laws and regulations, that describe the required characteristics a system must support. See also functional requirements, security requirements, technical requirements."
  },
  {
    "key": 281,
    "value": "Reidentification",
    "description": "The practice of associating anonymized or pseudonymized data with the original data subject. See also anonymization, data reconstruction attack, pseudonymization."
  },
  {
    "key": 282,
    "value": "Reinforcement learning",
    "description": "A type of machine learning where an AI system learns through interaction and receives feedback in the form of rewards and penalties."
  },
  {
    "key": 283,
    "value": "Release management",
    "description": "The IT function that controls the release of software programs, applications, and environments. See also IT service management (ITSM)."
  },
  {
    "key": 284,
    "value": "Reliability",
    "description": "A characteristic of responsible AI in which an AI system produces consistent results."
  },
  {
    "key": 285,
    "value": "Representativeness",
    "description": "Ensuring that data used to train an AI model captures relevant information for the AI system."
  },
  {
    "key": 286,
    "value": "Requirements",
    "description": "Formal statements that describe required (and desired) characteristics of a system that is to be changed, developed, or acquired. See also functional requirements, regulatory requirements, security requirements, technical requirements."
  },
  {
    "key": 287,
    "value": "Residual risk",
    "description": "Leftover risk that remains after a larger body of risk has been treated. See also risk treatment."
  },
  {
    "key": 288,
    "value": "Responsible AI",
    "description": "Principles to ensure that AI systems are designed, developed, and deployed in ways that respect human rights, promote fairness, and minimize risks while providing benefits to individuals, organizations, and society at large."
  },
  {
    "key": 289,
    "value": "Retirement",
    "description": "The planned shutdown of a system."
  },
  {
    "key": 290,
    "value": "Retrieval augmented generation (RAG)",
    "description": "A technique used by AI LLMs in which they will retrieve and incorporate new information to respond to a request."
  },
  {
    "key": 291,
    "value": "Reverse engineering",
    "description": "A method of examining a device, product, or system to understand its detailed design, despite the absence of helpful information."
  },
  {
    "key": 292,
    "value": "Right to audit",
    "description": "A clause in a contract that grants one party the right to conduct an audit of the other party’s operations."
  },
  {
    "key": 293,
    "value": "Risk",
    "description": "Generally, the fact that undesired events can happen that may damage property or disrupt operations, expressed as a combination of the event’s likelihood and impact."
  },
  {
    "key": 294,
    "value": "Risk acceptance",
    "description": "The risk treatment option in which management chooses to accept the risk as is."
  },
  {
    "key": 295,
    "value": "Risk appetite",
    "description": "The level of risk that an organization is willing to accept while in pursuit of its mission, strategy, and objectives, and before action is needed to treat or manage the risk. See also risk tolerance."
  },
  {
    "key": 296,
    "value": "Risk assessment",
    "description": "A process for identifying, analyzing, and evaluating risks, including threats, vulnerabilities, likelihood, and potential impact."
  },
  {
    "key": 297,
    "value": "Risk avoidance",
    "description": "The risk treatment option involving a cessation of the activity that introduces identified risk."
  },
  {
    "key": 298,
    "value": "Risk management",
    "description": "Management activities used to identify, analyze, and treat risks."
  },
  {
    "key": 299,
    "value": "Risk matrix",
    "description": "A simple two-dimensional table that depicts risk. Its two axes are Probability and Impact, which are usually identified in risk analysis."
  },
  {
    "key": 300,
    "value": "Risk mitigation",
    "description": "The risk treatment option involving the implementation of a solution that will reduce an identified risk."
  },
  {
    "key": 301,
    "value": "Risk register",
    "description": "A business record containing risks that have been identified."
  },
  {
    "key": 302,
    "value": "Risk tolerance",
    "description": "The amount of variation from the risk appetite that an organization is willing to accept in a particular situation. See risk appetite."
  },
  {
    "key": 303,
    "value": "Risk transfer",
    "description": "The risk treatment option of transferring risk to another party, such as an insurance company."
  },
  {
    "key": 304,
    "value": "Risk treatment",
    "description": "The decision to manage an identified risk. The available choices are to mitigate, avoid, transfer, or accept the risk. See also risk acceptance, risk appetite, risk avoidance, risk mitigation, risk tolerance, risk transfer."
  },
  {
    "key": 305,
    "value": "Robotics",
    "description": "A type of AI system capable of performing kinetic tasks."
  },
  {
    "key": 306,
    "value": "Rollback",
    "description": "A step in the system development lifecycle process in which system changes need to be reversed, returning the system to its previous state."
  },
  {
    "key": 307,
    "value": "Root cause analysis (RCA)",
    "description": "An incident review technique in which the ultimate cause of an incident is identified."
  },
  {
    "key": 308,
    "value": "Safety",
    "description": "A characteristic of an AI system whereby risks of harm are identified, minimized, and managed, so that the system operates within acceptable risk thresholds under reasonably foreseeable conditions."
  },
  {
    "key": 309,
    "value": "Schrödinger’s model",
    "description": "An AI system that appears both “in production” and “still in testing,” depending on which executive inquires."
  },
  {
    "key": 310,
    "value": "Secondary use",
    "description": "Uses of AI system outputs that differ from their original intended purpose."
  },
  {
    "key": 311,
    "value": "Security controls",
    "description": "Controls to ensure specific cybersecurity-related outcomes, particularly the protection of information systems and information. See also control."
  },
  {
    "key": 312,
    "value": "Security requirements",
    "description": "Formal statements that describe the required security characteristics that a system must support. See also functional requirements, regulatory requirements, technical requirements."
  },
  {
    "key": 313,
    "value": "Self-aware AI",
    "description": "The highest level of AI (hypothetical) that possesses consciousness and self-awareness."
  },
  {
    "key": 314,
    "value": "Semi-supervised learning",
    "description": "A type of AI system training using a small amount of labeled data and a large amount of unlabeled data."
  },
  {
    "key": 315,
    "value": "Shadow AI",
    "description": "Uses of AI that are deployed without approval."
  },
  {
    "key": 316,
    "value": "Shadow mode testing",
    "description": "The testing of an AI system in parallel with an existing process to determine whether the AI system produces the same outputs as the existing process."
  },
  {
    "key": 317,
    "value": "Simulatability",
    "description": "The ability for humans to understand and predict the output of an AI model with any given input."
  },
  {
    "key": 318,
    "value": "Simulation",
    "description": "A test of incident response procedures in which the participants take part in a “mock disaster” or incident to add some realism to the process of thinking their way through the emergency response process."
  },
  {
    "key": 319,
    "value": "Social engineering",
    "description": "The act of using deception to trick an individual into revealing secrets."
  },
  {
    "key": 320,
    "value": "Software bill of materials (SBOM)",
    "description": "The complete inventory of components, libraries, tools, and processes used to develop and build a software program. See also AI system bill of materials (AI-SBOM)."
  },
  {
    "key": 321,
    "value": "Software development lifecycle (SDLC)",
    "description": "See system development lifecycle (SDLC)."
  },
  {
    "key": 322,
    "value": "Spoofing, tampering, repudiation, information disclosure, denial of service, elevation of privilege (STRIDE)",
    "description": "A threat modeling technique developed by Microsoft."
  },
  {
    "key": 323,
    "value": "Standard contractual clauses (SCC)",
    "description": "Pre-approved contractual terms issued by regulators that can be used to transfer personal data to other countries lawfully. See also binding corporate rules (BCR)."
  },
  {
    "key": 324,
    "value": "Stochastic",
    "description": "AI algorithms or models that produce different outputs even when given the same input, due to the use of random sampling, probabilistic reasoning, or nondeterministic processes."
  },
  {
    "key": 325,
    "value": "Stress testing",
    "description": "A test of a system to observe its behavior under high loads, often to a breaking point."
  },
  {
    "key": 326,
    "value": "STRIDE",
    "description": "See spoofing, tampering, repudiation, information disclosure, denial of service, elevation of privilege."
  },
  {
    "key": 327,
    "value": "Superintelligent AI",
    "description": "See artificial superintelligence (ASI)."
  },
  {
    "key": 328,
    "value": "Supervised learning",
    "description": "A type of AI system training using pre-labeled (versus unlabeled) data. See also unsupervised learning."
  },
  {
    "key": 329,
    "value": "Sustainable",
    "description": "The characteristics of a business process, in which it is documented, repeatable, scalable, and resilient."
  },
  {
    "key": 330,
    "value": "Synthetic data",
    "description": "Artificially generated data, often used for system and application testing."
  },
  {
    "key": 331,
    "value": "System card",
    "description": "A document that describes an AI system’s characteristics and performance."
  },
  {
    "key": 332,
    "value": "System development lifecycle (SDLC)",
    "description": "The lifecycle process used to develop, acquire, and maintain information systems, also known as the software development lifecycle."
  },
  {
    "key": 333,
    "value": "Systemic risk",
    "description": "A characteristic of a general-purpose AI (GPAI) model that has high compute requirements, is integrated into critical infrastructure, or is known to influence human behavior at scale."
  },
  {
    "key": 334,
    "value": "Technical and organizational measures (TOMs)",
    "description": "Safeguards designed to protect personal data from unauthorized access, loss, or misuse."
  },
  {
    "key": 335,
    "value": "Technical requirements",
    "description": "Formal statements that describe the required technical characteristics that a system must support. See also functional requirements, regulatory requirements, security requirements."
  },
  {
    "key": 336,
    "value": "Theory of mind",
    "description": "A theoretical, advanced form of AI capable of understanding and simulating human emotions, beliefs, intentions, and thoughts."
  },
  {
    "key": 337,
    "value": "Third-party risk management (TPRM)",
    "description": "Business processes used to identify and manage risks related to vendors, service providers, and other third parties."
  },
  {
    "key": 338,
    "value": "Threat",
    "description": "An event that, if realized, would bring harm to an asset."
  },
  {
    "key": 339,
    "value": "Threat hunting",
    "description": "The proactive search for intrusions, intruders, and indicators of compromise."
  },
  {
    "key": 340,
    "value": "Threat modeling",
    "description": "The activity of looking for potential threats in a business process, an information system, or a software application."
  },
  {
    "key": 341,
    "value": "Throughput",
    "description": "A measure of the number of outputs an AI model can process within a given unit of time."
  },
  {
    "key": 342,
    "value": "Tort law",
    "description": "A branch of law used to determine compensation to individuals who suffer harm as a result of the actions of others. See also product liability."
  },
  {
    "key": 343,
    "value": "Trade secret",
    "description": "A form of intellectual property, typically the design of a product or process, that its owner chooses to conceal from the public, and whose secrecy provides economic value."
  },
  {
    "key": 344,
    "value": "Transfer impact assessment (TIA)",
    "description": "A risk assessment used to identify regulatory risks related to cross-border data transfers of personal information."
  },
  {
    "key": 345,
    "value": "Transparency",
    "description": "A characteristic of an AI system in which its logic and workings are observable and explainable."
  },
  {
    "key": 346,
    "value": "Transparency summary",
    "description": "See model card."
  },
  {
    "key": 347,
    "value": "Uncertainty",
    "description": "A characteristic of some AI systems in which the outcomes or outputs are not deterministic."
  },
  {
    "key": 348,
    "value": "Underfitting",
    "description": "The result when an AI model is trained with insufficient data, an overly simple model architecture, or inadequate training. See also overfitting."
  },
  {
    "key": 349,
    "value": "Unfair or deceptive acts or practices (UDAP)",
    "description": "Activities, typically marketing and advertising, that mislead, deceive, manipulate, or harm persons."
  },
  {
    "key": 350,
    "value": "Unit testing",
    "description": "The practice of system testing, in which individual modules are tested."
  },
  {
    "key": 351,
    "value": "Unsupervised learning",
    "description": "A type of AI system training using unlabeled (versus pre-labeled) data. See also supervised learning."
  },
  {
    "key": 352,
    "value": "Upsampling",
    "description": "Increasing the number of data points in a dataset, usually by duplicating or synthetically generating new samples. See also downsampling."
  },
  {
    "key": 353,
    "value": "Use case",
    "description": "A formal description of how a system will operate, the data it will use, and the outcome(s) it is expected to deliver."
  },
  {
    "key": 354,
    "value": "User",
    "description": "A business or customer that interacts with or consumes the output of a system. See also AI user."
  },
  {
    "key": 355,
    "value": "Version control",
    "description": "The techniques and tools used to manage different versions of source code files and business documents."
  },
  {
    "key": 356,
    "value": "Vulnerability",
    "description": "A weakness present in a system that makes the probability of one or more threats more likely."
  },
  {
    "key": 357,
    "value": "World Wide Web Consortium (W3C) PROV",
    "description": "A set of recommended standards for the structure of data provenance information."
  },
  {
    "key": 358,
    "value": "Zero-shot learning",
    "description": "A machine learning technique in which the model is trained to recognize and categorize objects or concepts without having seen examples of them beforehand."
  }
];
